

        jQuery(function() {
            var $module = jQuery('#m-1527298713919').children('.module');
            $module.gfV3Product();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527299791038').children('.module');
            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';

            var blankOption = $module.attr('data-blankoption');
            var blankOptionText = $module.attr('data-blankoptiontext');

            $module.gfV3ProductVariants({
                'mode': mode,
                'blankOption': blankOption,
                'blankOptionText': blankOptionText
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527299985452').children('.module');
            var style = $module.attr('data-style');
            var updatePrice = $module.attr('data-updateprice');

            $module.gfV3ProductQuantity({
                'style': style,
                'updatePrice': updatePrice
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527300007830').children('.module');
            $module.gfV3ProductCartButton();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527298713919-0').children('.module');
            var effect = $module.attr('data-effect');
            $module.gfV3ProductImage({
                'effect': effect
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527303462533').children('.module');
            $module.gfV3ProductImageList({
                onImageClicked: function(imageUrl, imageZoomUrl) {}
            });

            var slider = $module.attr('data-slider');
            if(slider == '1') {
                var columns = $module.attr('data-columns');
                var navspeed = $module.attr('data-navspeed');

                $module.find('.gf_product-images-list').owlCarousel({
                    mouseDrag: true,
                    nav: 1,
                    dots: 0,
                    autoWidth: !1,
                    navSpeed: navspeed,
                    items: columns,
                    responsive: {
                        0: {
                            items: 3,
                            nav: 1, 
                            dots: 0 
                        },
                        768: {
                            items: columns,
                            nav: 1, 
                            dots: 0 
                        },
                        992: {      
                            items: columns,
                            nav: 1, 
                            dots: 0,
                        },
                        1200: {      
                            items: columns,
                            nav: 1, 
                            dots: 0 
                        }
                    }
                }); 
            }
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527298713919-1').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527298713919-2').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527300316257').children('.module');
            var btnLabel = $module.attr('data-btnlabel');
            $module.gfSocialShare({
                btnLabel: btnLabel
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1527301561583').children('.module');
            var single   = $module.attr('data-single');
            var openDefault  = $module.attr('data-openDefault');
            var openTab  = $module.attr('data-openTab');
            var mode     = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';

            if(openDefault == 0 || openDefault == '0') {
                openTab = '0';
            }

            $module.gfAccordion({
                single: single,
                openTab: openTab,
                mode: mode
            });

            var borderColor = $module.attr('data-borderColor');
            var borderSize = $module.attr('data-borderSize');

            $module.children('[data-accordion]').children('[data-control]').css('border-bottom', borderSize + ' solid ' + borderColor);
            $module.children('[data-accordion]').children('[data-content]').children().css('border-bottom', borderSize + ' solid ' + borderColor);
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1527307905188').children('.module');

        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1527304629398').children('.module');

            var limit = parseInt($module.attr('data-limit'));
            if($module.find('.gf_row.gf_row_no_tools .gf_column').length > limit) {
                $module.find('.gf_row.gf_row_no_tools .gf_column:last').hide();
            }
        }); 
    